if (!customElements.get('product-video-modal')) {
  customElements.define(
    'product-video-modal',
    class ProductVideoModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('[role="dialog"]');
        this.player = this.querySelector('[data-product-video-player]');
        this.closeButton = this.querySelector('[data-product-video-close]');
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handlePopState = this.handlePopState.bind(this);
        this.close = this.close.bind(this);
      }

      connectedCallback() {
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keyup', this.handleKeyUp);
        window.addEventListener('popstate', this.handlePopState);
        this.closeButton.addEventListener('click', this.close);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keyup', this.handleKeyUp);
        window.removeEventListener('popstate', this.handlePopState);
        this.closeButton.removeEventListener('click', this.close);
      }

      handleDocumentClick(event) {
        const opener = event.target.closest('[data-product-video-open]');
        if (!opener || opener.dataset.productVideoModal !== `#${this.id}`) return;

        event.preventDefault();
        event.stopPropagation();
        this.open(opener);
      }

      open(opener) {
        const container = opener.closest('.product-video-square');
        const template = container?.querySelector('[data-product-video-template]');
        const video = template?.content.querySelector('video')?.cloneNode(true);
        if (!video) return;

        this.opener = opener;
        this.scrollPosition = window.scrollY;
        this.video = video;
        this.video.controls = true;
        this.video.loop = false;
        this.video.playsInline = true;
        this.video.addEventListener('ended', this.close, { once: true });
        this.player.replaceChildren(this.video);

        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('product-video-modal-open');

        history.pushState(
          { ...history.state, productVideoModal: this.id },
          '',
          window.location.href
        );
        this.historyEntryActive = true;

        if (typeof trapFocus === 'function') {
          trapFocus(this, this.closeButton);
        } else {
          this.dialog.focus();
        }

        const playPromise = this.video.play();
        if (playPromise) playPromise.catch(() => this.video.focus());
      }

      close() {
        if (!this.hasAttribute('open')) return;

        const removeHistoryEntry =
          this.historyEntryActive && history.state?.productVideoModal === this.id;
        this.finishClose();
        if (removeHistoryEntry) history.back();
      }

      finishClose() {
        this.historyEntryActive = false;
        if (this.video) {
          this.video.pause();
          this.video.removeEventListener('ended', this.close);
        }
        this.player.replaceChildren();
        this.video = null;
        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('product-video-modal-open');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.opener);
        } else {
          this.opener?.focus();
        }

        window.scrollTo(0, this.scrollPosition);
      }

      handleKeyUp(event) {
        if (event.code === 'Escape' && this.hasAttribute('open')) this.close();
      }

      handlePopState(event) {
        if (!this.historyEntryActive || !this.hasAttribute('open')) return;
        if (event.state?.productVideoModal === this.id) return;
        this.finishClose();
      }
    }
  );
}
